import Chart from 'react-apexcharts'


const PieFormatter = (arr) => {
    const series = []
    const labels = []
    var lbl = ''
    if (arr) {
        Object.entries(arr).forEach(([key, value]) => {
            series.push(parseFloat(value.slice(2).replace(/,/g, '')))
            lbl = key.split('_')[1].trim()
            switch (lbl) {
                case 'Cybersource':
                    labels.push('Pagos en línea')
                    break
                case 'Bancos':
                    labels.push('Agencias bancarias')
                    break
                case 'Efectivo':
                    labels.push('Efectivo')
                    break
                case 'Boleta':
                    labels.push('Reg. boleta')
                    break
                case 'POS':
                    labels.push('P.O.S.')
                    break
                default:
                    labels.push('')
            }
            //labels.push(key.split('_')[1].trim())
        })
    }
    return [series, labels]
}

const PieChart = ({ data, title, month, year }) => {


    const lastReport = data[data.length - 1]
    const [series, labels] = PieFormatter(lastReport)

    const objChartPie = {
        options: {
            legend: {
                position: 'bottom',
                labels: {
                    colors: ['#fff'],
                },
                markers: {
                    radius: 3,
                },
            },
            stroke: {
                colors: ['#233044'],
                width: 3,
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: '75%',
                        labels: {
                            show: false,
                        }
                    }
                }
            },
            theme: {
                mode: 'light',
                palette: 'palette6',
            },
            tooltip: {
                y: {
                    formatter: (value) => {
                        return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
                    }
                },
            },
            //colors: ['#E68A00', '#4782da', '#FF1D0D', '#2e4b76'],
            labels: labels.slice(0, -1)
        },
        series: series.slice(0, -1),
    }

    return (
        <div className='bg-primarioMira rounded-lg p-5 w-full h-full'>

            <div className="lg:col-span-1 mb-5">
                <h3 className="text-lg font-medium leading-6 text-white">Gráfica</h3>
                <h4 className="text-lg font-medium leading-6 text-white"> {title} - {month} {year} </h4>
                <p className="mt-1 text-sm text-grisMira">Según forma de pago</p>
            </div>

            <Chart
                options={objChartPie.options}
                series={objChartPie.series}
                type='donut'
                height='360px'
            />

        </div>
    )
}

export default PieChart